import React from "react";
import { Button, Col, Row } from "react-bootstrap";

const ServerErrorComponent = ({data, error, setStep}) => {

    const btnHandler = () => {
        if ("qr_code" in data && data.qr_code && data.qr_code !== null && data.qr_code !== "") {
            return setStep(1)
        }
        return setStep(2);
    }

    return (
        <div className="text-center">
            <h4 className="text-danger">Fehler aufgetreten!</h4>
            <Row className="mt-3 justify-content-center">
                <Col xs="12" xl="8">
                    <p>{error}</p>
                </Col>
            </Row>
            <Row>
                <Col xl="12" className="text-end">
                    <Button onClick={() => btnHandler()} variant="warning">Erneut versuchen</Button>
                </Col>
            </Row>
        </div>
    )
}

export default ServerErrorComponent;